import React from 'react';
import { useTranslation } from 'react-i18next';

import { InvoiceStatus } from '@app/api';
import { Chip } from '@app/core';
import { Colors } from '@app/theme';

interface Props {
  className?: string;
  status: InvoiceStatus;
}

const StatusColor = {
  [InvoiceStatus.OPEN]: 'yellow',
  [InvoiceStatus.PAID]: 'green',
  [InvoiceStatus.VOID]: 'red',
  [InvoiceStatus.UNCOLLECTIBLE]: 'red',
  [InvoiceStatus.DRAFT]: 'ink',
  [InvoiceStatus.REFUNDED]: 'blue',
} as Record<InvoiceStatus, Colors>;

export const InvoiceStatusChip = ({ className, status }: Props) => {
  const { t } = useTranslation();

  return (
    <Chip color={StatusColor[status]} className={className}>
      {t(`billing.invoice.status.${status}`)}
    </Chip>
  );
};
